import { i18next } from '../i18n';
import type { VoiceAction, VoiceActionTypeValue } from '../types/voice';

export function voiceActionTypeLabel(type: VoiceActionTypeValue): string {
    return i18next.t(`voiceActionTypes.${type}`);
}

export function voiceActionDisplayTitle(action: VoiceAction): string {
    return action.displayTitle?.trim() ?? '';
}

export function voiceActionErrorContext(action: VoiceAction): string {
    const t = voiceActionDisplayTitle(action);
    if (t) return t;
    switch (action.type) {
        case 'CREATE_CATEGORY':
            return action.categoryName;
        case 'CREATE_ACHIEVEMENT':
            return action.achievementName;
        case 'CREATE_QUEST':
        case 'POSTPONE_QUEST':
            return action.questName;
    }
}

export function voiceDependentAfterLine(dependentActions?: VoiceAction[]): string | null {
    if (!dependentActions?.length) return null;
    const firstType = voiceActionTypeLabel(dependentActions[0].type);
    const names = dependentActions.map(voiceActionDisplayTitle).filter(Boolean);
    if (!names.length) return i18next.t('voice.after', { type: firstType });
    return `${i18next.t('voice.after', { type: firstType })} · ${names.join(', ')}`;
}
